import React from 'react'
import PropTypes from 'prop-types'
import {FormGroup, FieldStatus, Input} from 'rambler-ui'
import {createDeferHandler} from '@rambler-id/react'

export default function TextField({
  label,
  inline,
  size,
  className = '',
  autoComplete,
  message,
  error: errorMessage,
  type = 'text',
  maxLength,
  autoFocus,
  placeholder,
  meta,
  input,
  cerberId,
  disabled,
  statusClassName
}) {
  const error = meta.touched && (errorMessage || meta.error)
  const status = error ? 'error' : message ? 'success' : null

  return (
    <FormGroup
      inline={inline}
      label={label}
      fieldId={input.name}
      className={className}>
      <FieldStatus
        type={status}
        message={error || message}
        className={statusClassName}>
        <Input
          {...input}
          autoComplete={autoComplete}
          inputClassName="-metrika-nokeys"
          type={type}
          maxLength={maxLength}
          id={input.name}
          size={size}
          status={status}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          onBlur={createDeferHandler(input.onBlur)}
          data-cerber-id={cerberId}
        />
      </FieldStatus>
    </FormGroup>
  )
}

TextField.propTypes = {
  inline: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  message: PropTypes.node,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  disabled: PropTypes.bool,
  cerberId: PropTypes.string
}
